import React from "react";
import { Button, CircularProgress, Container, FormControl, InputLabel, MenuItem, Select, TextField } from "@material-ui/core";
import useGenerateUrlController from "../useGenerateUrlController";
import { Autocomplete } from "@material-ui/lab";
import CopyLinkToClipboard from  "../CopyLinkToClipboard";
import { WAVE_URL } from "../constants";
import "../style.css";

export default ({ id }) => {
  const {
    handleGetOptionSelected,
    handleAutoCompleteOnChange,
    handleAutocompleteInputChange,
    urlProps,
    projectsProps,
    destinationsProps,
} = useGenerateUrlController(id, WAVE_URL);

const { appUrl, isUrlCopied, setIsUrlCopied, isGenerateUrlButtonDisabled, generateUrl } = urlProps;
const { projectInputLabel, projectLabelWidth, projects, selectedProject,  setSelectedProject, loadingProjects } = projectsProps;
const { destinations, loadingDestinations, isDestinationsInputOpen,  setIsDestinationsInputOpen, destinationsInputValue } = destinationsProps;
  
  /** Material UI Autocomplete handle functions */ 
  function renderInputField(params) {
    return (
      <TextField
        {...params}
        label="Destinations"
        variant="outlined"
        InputProps={{
          ...params.InputProps,
          endAdornment: (
            <>
              {loadingDestinations ? <CircularProgress size={20} /> : null}
              {params.InputProps.endAdornment}
            </>
          ),
        }}
      />
    );
  }

  return (
    <div className="curbside-app-url">
      <Container maxWidth="xl" className="white-card main-container">
        <h5 className="title">Generate URL for Wave Demo App</h5>
        <div className="columns-wrapper">
          <div>
            <p>
              Generates a URL that can be used to demonstrate to link the
              Wave Demo App with Hello Screens.
            </p>
            <div className="important-notes">
              <h5>Important</h5>
              <ul>
                <li>Only shows the first 100 Projects of this account</li>
              </ul>
            </div>
          </div>

          <div className="url-form-wrapper">
            <div className="select-inputs-wrapper">
              <FormControl variant="outlined" className="select-input">
                <InputLabel ref={projectInputLabel} id="project-input-label">
                  {!loadingProjects ? "Project" : <CircularProgress size={20} />}
                </InputLabel>
                <Select
                  value={selectedProject}
                  onChange={(e) => setSelectedProject(e.target.value)}
                  labelWidth={projectLabelWidth}
                  width={200}
                  disabled={!(projects && projects.length)}
                >
                  {projects.map((project) => (
                    <MenuItem key={project._id} value={project}>
                      {project.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <FormControl variant="outlined" className="select-input">
                <Autocomplete
                  id="asynchronous-autocomplete-zones"
                  open={isDestinationsInputOpen}
                  onOpen={() => setIsDestinationsInputOpen(true)}
                  onClose={() => setIsDestinationsInputOpen(false)}
                  getOptionSelected={handleGetOptionSelected}
                  getOptionLabel={(destination) => destination.name}
                  options={destinations}
                  loading={loadingDestinations}
                  disabled={!selectedProject || loadingDestinations}
                  inputValue={destinationsInputValue}
                  onChange={handleAutoCompleteOnChange}
                  onInputChange={handleAutocompleteInputChange}
                  renderInput={renderInputField}
                />
              </FormControl>
            </div>
            <div className="generate-url-button-wrapper">
              <Button
                variant="contained"
                color="primary"
                disableElevation
                onClick={generateUrl}
                disabled={isGenerateUrlButtonDisabled()}
              >
                Generate URL
              </Button>
            </div>
            <CopyLinkToClipboard url={appUrl} setIsUrlCopied={setIsUrlCopied} isUrlCopied={isUrlCopied} />
          </div>
        </div>
      </Container>
    </div>
  );
};
